import { Component, OnDestroy, OnInit } from '@angular/core';
import { EmbedInfoService } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import { CustomerSettings } from '../services/customer-settings-service';

@Component({
  selector: 'app-image-host',
  templateUrl: './image-host.component.html',
  styleUrls: ['./image-host.component.scss']
})
export class ImageHostComponent extends PagebaseComponent implements OnInit, OnDestroy {
  // Public variables
  loading: boolean = true;
  showKpi: boolean = false;

  kpiImages: string[] = [
    "../../assets/img/kpi-report-1.png",
    "../../assets/img/kpi-report-2.png",
    "../../assets/img/kpi-report-3.png",
    "../../assets/img/kpi-report-4.png",
    "../../assets/img/kpi-report-5.png",
    "../../assets/img/kpi-report-6.png",
    "../../assets/img/kpi-report-7.png"
  ]

  vehicleImages: string[] = [
    "../../assets/img/vehicle-utilisation-1.png",
    "../../assets/img/vehicle-utilisation-2.png",
    "../../assets/img/vehicle-utilisation-3.png",
    "../../assets/img/vehicle-utilisation-4.png"
  ]

  imageIndex: number = 0;
  currentImage: string = "";

  constructor(private _embedInfoService: EmbedInfoService, pageHelperService: PageHelperService, applicationStatusService: ApplicationStatusService, private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Image Host");
  }

  ngOnInit() {
    this.getReportPageName();
    
    if (this.showKpi) {
      this.currentImage = this.kpiImages[0];
    } else {
      this.currentImage = this.vehicleImages[0];
    }

    console.log(this.currentImage);
  }
   
  nextImage() {
    this.imageIndex++;
    if (this.showKpi) {
      if (this.imageIndex > this.kpiImages.length - 1) {
        this.imageIndex = 0;
      }
      this.currentImage = this.kpiImages[this.imageIndex];
    } else {
      if (this.imageIndex > this.vehicleImages.length - 1) {
        this.imageIndex = 0;
      }
      this.currentImage = this.vehicleImages[this.imageIndex];
    }

    console.log(this.currentImage);
  }

  ngOnDestroy(): void {
    this.reset();
  }

  getData() {
    this.loading = false;
    this.setIsLoading(this.loading);
  }

  getReportPageName() {
    switch (window.location.pathname) {
      case "/kpi-reports":
        this.showKpi = true;
        break
      default:
        this.showKpi = false;
    }
  }

  reset(): void {
  }
}
